(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }
        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["linton-pdp"] && !Shopify.designMode) return;
  try {
    
// Gedeelde helpers: config (add-on-slots p1/p2/p3 + kortingsbedragen), prijsprojectie en multi-item cart-add.
window.LINTON=(function(){
  var cfg={disc:{},addons:{}};
  var el=document.querySelector('[data-linton-config]');
  if(el){try{cfg=JSON.parse(el.textContent);}catch(e){}}
  if(!cfg.disc){cfg.disc={};}
  if(!cfg.addons){cfg.addons={};}
  function euro(c){c=Math.round((c||0)/100);return c<=0?'Gratis':'€'+c.toLocaleString('nl-NL');}
  function colorKey(s){s=(s||'').toLowerCase();
    if(s.indexOf('waln')>-1){return 'walnut';}
    if(s.indexOf('zwart')>-1||s.indexOf('black')>-1||s.indexOf('noir')>-1){return 'black';}
    if(s.indexOf('mahon')>-1||s.indexOf('mahog')>-1){return 'mahogany';}
    if(s.indexOf('eik')>-1||s.indexOf('oak')>-1){return 'oak';}
    if(s.indexOf('wit')>-1||s.indexOf('white')>-1){return 'white';}
    return s;}
  // Add-on-slots (Product 1/2/3 uit de section-instellingen). Elke add-on draagt zijn
  // eigen vaste kortingsbedrag per stuk (cents); korting vereist ≥1 ankerproduct in de cart.
  var KEYS=['p1','p2','p3'];
  function addon(key){return cfg.addons?cfg.addons[key]:null;}
  function discFor(key,hasAnchor){var a=addon(key);if(!a||!hasAnchor){return 0;}return a.disc||0;}
  // Levertijd-indicator op basis van dezelfde voorraadlogica als de Linton-koopzone.
  // Compact voor de add-on-kaarten in de koopzone; met bundle=true de uitgebreidere
  // teksten voor de bundelsectie.
  function stockHtml(v,bundle){
    var green='<span class="deliver__dot"></span>';
    var amber='<span class="deliver__dot" style="background:#c98a2b;box-shadow:0 0 0 3px rgba(201,138,43,.18)"></span>';
    var red='<span class="deliver__dot" style="background:#b23b3b;box-shadow:0 0 0 3px rgba(178,59,59,.18)"></span>';
    function msg(dot,txt){return dot+'<span>'+txt+'</span>';}
    var tracked=v.inv_managed==='shopify';
    if(!v.available){return msg(red,bundle?'Tijdelijk uitverkocht - Levering onbekend':'Tijdelijk uitverkocht');}
    if(tracked&&v.inv_qty<=0){var d=v.restock?v.restock:'onbekend';return msg(amber,(bundle?'Verwachte levering: ':'Levering: ')+'<b>'+d+'</b>');}
    return msg(green,bundle?'Voor 16:00, <b>morgen geleverd</b>':'<b>Op voorraad</b>');
  }
  function variantById(list,id){if(!list){return null;}for(var i=0;i<list.length;i++){if(String(list[i].id)===String(id)){return list[i];}}return null;}
  function cartAdd(items){
    var url=cfg.cartUrl||'/cart';
    return fetch(url+'/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){if(!r.ok){return r.json().then(function(j){throw new Error((j&&j.description)||'cart error');});}return r.json();})
      .then(function(){window.location.href=url;});
  }
  return {cfg:cfg,KEYS:KEYS,euro:euro,colorKey:colorKey,discFor:discFor,addon:addon,stockHtml:stockHtml,variantById:variantById,cartAdd:cartAdd};
})();
(function(){
  var slides=[].slice.call(document.querySelectorAll('#stage .slide'));
  var thumbs=[].slice.call(document.querySelectorAll('#thumbs .thumb'));
  var stage=document.getElementById('stage');
  var cursor=document.getElementById('stageCursor');
  var zoom=document.getElementById('stageZoom');
  var lb=document.getElementById('lightbox'),lbImg=document.getElementById('lightboxImg'),lbClose=document.getElementById('lightboxClose');
  var cur=0;
  function curImg(){var s=slides[cur];return s?s.querySelector('img.asset'):null;}
  function show(i){
    cur=(i+slides.length)%slides.length;
    slides.forEach(function(s){s.classList.remove('on')});
    thumbs.forEach(function(x){x.classList.remove('on')});
    slides[cur].classList.add('on');
    if(thumbs[cur]){thumbs[cur].classList.add('on');try{thumbs[cur].scrollIntoView({inline:'center',block:'nearest'});}catch(e){}}
    if(slides[cur].querySelector('.proof')){stage.classList.add('stage--proof');}else{stage.classList.remove('stage--proof');}
  }
  // Laat de koopzone (variantwissel) naar de bij de variant horende media springen.
  window.__lintonShowMedia=function(id){if(!id){return false;}for(var k=0;k<slides.length;k++){if(slides[k].getAttribute('data-media-id')===String(id)){show(k);return true;}}return false;};
  thumbs.forEach(function(t,i){t.addEventListener('click',function(){show(i);});});
  // Muiswiel (verticaal) over de thumb-strip → horizontaal scrollen, zoals op een touchpad.
  var thumbStrip=document.getElementById('thumbs');
  if(thumbStrip){thumbStrip.addEventListener('wheel',function(e){
    if(Math.abs(e.deltaY)>Math.abs(e.deltaX)){e.preventDefault();thumbStrip.scrollLeft+=e.deltaY;}
  },{passive:false});}
  if(cursor){
    stage.addEventListener('mousemove',function(e){
      if(e.target.closest('.stage__zoom')){stage.classList.remove('cursor-on');return;}
      var r=stage.getBoundingClientRect(),x=e.clientX-r.left,y=e.clientY-r.top;
      cursor.style.left=x+'px';cursor.style.top=y+'px';
      cursor.textContent=(x<r.width/2)?'\u2039':'\u203a';
      stage.classList.add('cursor-on');
    });
    stage.addEventListener('mouseleave',function(){stage.classList.remove('cursor-on');});
  }
  stage.addEventListener('click',function(e){
    if(e.target.closest('.stage__zoom'))return;
    if(stage.dataset.swiping==='1'){stage.dataset.swiping='';return;}
    var r=stage.getBoundingClientRect();
    show((e.clientX-r.left)<r.width/2?cur-1:cur+1);
  });
  // Touch-swipe op de hoofdafbeelding (vorige/volgende).
  var _tx=null,_ty=null;
  stage.addEventListener('touchstart',function(e){var t=e.changedTouches[0];_tx=t.clientX;_ty=t.clientY;},{passive:true});
  stage.addEventListener('touchend',function(e){
    if(_tx===null){return;}
    var t=e.changedTouches[0],dx=t.clientX-_tx,dy=t.clientY-_ty;
    if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)){stage.dataset.swiping='1';show(dx<0?cur+1:cur-1);}
    _tx=null;_ty=null;
  },{passive:true});
  function openLb(){var im=curImg();if(!im||!lb)return;lbImg.src=im.src;lbImg.alt=im.alt||'';lb.classList.add('open');lb.setAttribute('aria-hidden','false');}
  function closeLb(){if(!lb)return;lb.classList.remove('open');lb.setAttribute('aria-hidden','true');}
  if(zoom){zoom.addEventListener('click',function(e){e.stopPropagation();openLb();});}
  if(lb){lb.addEventListener('click',function(e){if(e.target===lb){closeLb();}});}
  if(lbClose){lbClose.addEventListener('click',function(e){e.stopPropagation();closeLb();});}
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeLb();}});
})();
(function(){
  // Koopzone: variantkeuze + add-ons (Product 1/2/3) → geprojecteerd totaal + multi-item cart-add.
  var L=window.LINTON;
  var form=document.getElementById('lintonForm');
  var dataEl=document.querySelector('[data-linton-variants]');
  if(!form||!dataEl||!L){return;}
  var variants=[];
  try{variants=JSON.parse(dataEl.textContent);}catch(e){return;}
  var idInput=document.getElementById('lintonVariantId');
  var sws=[].slice.call(document.querySelectorAll('#swatches .sw'));
  var fins=[].slice.call(document.querySelectorAll('.addon-fin'));
  var now=document.getElementById('priceNow'),was=document.getElementById('priceWas'),save=document.getElementById('priceSave');
  var ctaTotal=document.getElementById('ctaTotal'),addBtn=document.getElementById('lintonAddBtn'),deliver=document.getElementById('lintonDeliver');
  var euro=L.euro,colorKey=L.colorKey;
  var currentLinton=null;
  function byVid(vid){for(var i=0;i<variants.length;i++){if(String(variants[i].id)===String(vid)){return variants[i];}}return null;}
  function deliverHtml(v){
    var green='<span class="deliver__dot"></span>';
    var amber='<span class="deliver__dot" style="background:#c98a2b;box-shadow:0 0 0 3px rgba(201,138,43,.18)"></span>';
    var red='<span class="deliver__dot" style="background:#b23b3b;box-shadow:0 0 0 3px rgba(178,59,59,.18)"></span>';
    var tracked=v.inv_managed==='shopify';
    function msg(dot,txt){return dot+'<span>'+txt+'</span>';}
    if(!v.available){return msg(red,'Tijdelijk uitverkocht');}
    if(tracked && v.inv_qty<=0){var d=v.restock ? v.restock : 'onbekend';return msg(amber,'Tijdelijk uitverkocht — verwachte leverdatum <b>'+d+'</b>');}
    if(tracked && v.inv_qty>0 && v.inv_qty<=5){return msg(green,'Bijna uitverkocht — voor 16:00 besteld, <b>morgen in huis</b>');}
    return msg(green,'Op voorraad — voor 16:00 besteld, <b>morgen in huis</b>');
  }
  // --- Add-ons (Product 1/2/3) ---
  function cb(key){return document.querySelector('.addon-cb[data-addon="'+key+'"]');}
  function addonVariant(key){
    var sel=document.querySelector('[data-addon-fin="'+key+'"]'),data=L.addon(key);
    if(!sel||!data){return null;}
    return L.variantById(data.variants,sel.value);
  }
  function paintAddon(key,disc){
    var box=document.querySelector('[data-addon-price="'+key+'"]');if(!box){return;}
    var v=addonVariant(key);if(!v){return;}
    var wasEl=box.querySelector('[data-was]'),nowEl=box.querySelector('[data-now]'),saveEl=box.querySelector('[data-save]');
    var proj=Math.max(0,v.price-disc);
    if(nowEl){nowEl.textContent=euro(proj);}
    if(disc>0){if(wasEl){wasEl.textContent=euro(v.price);wasEl.hidden=false;}if(saveEl){saveEl.textContent=euro(disc)+' korting';saveEl.hidden=false;}}
    else{if(wasEl){wasEl.hidden=true;}if(saveEl){saveEl.hidden=true;}}
    var st=document.querySelector('[data-addon-stock="'+key+'"]');
    if(st){st.innerHTML=L.stockHtml(v);}
    // Afbeelding volgt de gekozen kleurvariant (fallback: productafbeelding).
    var im=document.querySelector('[data-addon-img="'+key+'"] img');
    if(im){var a=L.addon(key),src=v.img||(a&&a.img);if(src){im.src=src;im.removeAttribute('srcset');}}
  }
  function recompute(){
    var total=currentLinton?currentLinton.price:0;
    var wasT=currentLinton?(currentLinton.compare>currentLinton.price?currentLinton.compare:currentLinton.price):0;
    var names=[];
    L.KEYS.forEach(function(key){
      var disc=L.discFor(key,true);
      paintAddon(key,disc);
      var c=cb(key);
      if(c&&c.checked){
        var v=addonVariant(key);
        if(v){
          var proj=Math.max(0,v.price-disc);
          total+=proj;wasT+=v.price;
          var a=L.addon(key);
          names.push('+ '+((a&&a.title)||'add-on')+' <span class="stickybar__fin">· '+(v.option||'')+'</span> ('+euro(proj)+')');
        }
      }
    });
    if(ctaTotal){ctaTotal.textContent=euro(total);}
    // Sticky bar: totaal incl. add-ons, was-prijs, voordeel en de geselecteerde add-ons.
    var sT=document.getElementById('stickyTotal'),sW=document.getElementById('stickyWas'),sS=document.getElementById('stickySave'),sA=document.getElementById('stickyAddons');
    if(sT){sT.textContent=euro(total);}
    if(sW){if(wasT>total){sW.textContent=euro(wasT);sW.hidden=false;}else{sW.hidden=true;}}
    if(sS){if(wasT>total){sS.textContent=euro(wasT-total)+' korting';sS.hidden=false;}else{sS.hidden=true;}}
    if(sA){if(names.length){sA.innerHTML=names.map(function(n){return '<div>'+n+'</div>';}).join('');sA.hidden=false;}else{sA.hidden=true;}}
  }
  function apply(v,jump){
    if(!v){return;}
    currentLinton=v;
    if(idInput){idInput.value=v.id;}
    if(now){now.textContent=euro(v.price);}
    if(v.compare>v.price){
      if(was){was.textContent=euro(v.compare);was.hidden=false;}
      var s=v.compare-v.price,pct=Math.round(s/v.compare*100);
      if(save){save.textContent=euro(s)+' korting · '+pct+'%';save.hidden=false;}
    }else{
      if(was){was.hidden=true;}
      if(save){save.hidden=true;}
    }
    if(addBtn){
      addBtn.disabled=!v.available;
      var lbl=addBtn.querySelector('.cta__total');
      addBtn.firstChild.textContent=v.available?'In winkelwagen — ':'Tijdelijk uitverkocht ';
      if(lbl){lbl.style.display=v.available?'':'none';}
    }
    if(deliver){deliver.innerHTML=deliverHtml(v);}
    // Sticky bar: gekozen kleur subtiel vermelden + thumbnail mee laten wisselen.
    var sFin=document.getElementById('lintonStickyFin');
    if(sFin){sFin.textContent=v.option;}
    var sIm=document.querySelector('#stickybar .stickybar__img img');
    if(sIm&&v.img){sIm.src=v.img;sIm.removeAttribute('srcset');}
    if(jump && v.fmid && typeof window.__lintonShowMedia==='function'){window.__lintonShowMedia(v.fmid);}
    recompute();
  }
  function syncFin(f,key){for(var i=0;i<f.options.length;i++){if(colorKey(f.options[i].text)===key){f.selectedIndex=i;return;}}}
  sws.forEach(function(s){s.addEventListener('click',function(){
    sws.forEach(function(x){x.classList.remove('on');});s.classList.add('on');
    var key=colorKey(s.getAttribute('data-c'));
    fins.forEach(function(f){syncFin(f,key);});
    apply(byVid(s.getAttribute('data-vid')),true);
  });});
  L.KEYS.forEach(function(key){
    var c=cb(key);if(c){c.addEventListener('change',recompute);}
    var sel=document.querySelector('[data-addon-fin="'+key+'"]');if(sel){sel.addEventListener('change',recompute);}
  });
  // Multi-item toevoegen: Linton + aangevinkte add-ons in de gekozen afwerking.
  form.addEventListener('submit',function(e){
    e.preventDefault();
    if(addBtn&&addBtn.disabled){return;}
    var items=[{id:parseInt(idInput.value,10),quantity:1}];
    L.KEYS.forEach(function(key){
      var c=cb(key);if(c&&c.checked){var v=addonVariant(key);if(v&&v.available){items.push({id:v.id,quantity:1});}}
    });
    if(addBtn){addBtn.disabled=true;}
    L.cartAdd(items).catch(function(){if(addBtn){addBtn.disabled=false;}form.submit();});
  });
  var active=document.querySelector('#swatches .sw.on')||sws[0];
  if(active){apply(byVid(active.getAttribute('data-vid')),false);}
  else{currentLinton=byVid(idInput.value)||variants[0];recompute();}
  var sticky=document.getElementById('lintonStickyBtn');
  if(sticky){sticky.addEventListener('click',function(){
    if(typeof form.requestSubmit==='function'){form.requestSubmit();}else{form.submit();}
  });}
})();
(function(){
  var wrap=document.querySelector('.addon-more'),btn=document.getElementById('addonMoreBtn');
  if(wrap&&btn){btn.addEventListener('click',function(){wrap.classList.toggle('open');});}
})();
(function(){
  [].slice.call(document.querySelectorAll('.q__btn')).forEach(function(b){b.addEventListener('click',function(){b.parentNode.classList.toggle('open')});});
  [].slice.call(document.querySelectorAll('.acc__btn')).forEach(function(b){b.addEventListener('click',function(){b.parentNode.classList.toggle('open')});});
})();
(function(){
  // Bundelsectie: echte varianten, kortingsprojectie per add-on-slot + multi-item cart-add.
  var L=window.LINTON;
  var box=document.getElementById('bundle');if(!box||!L){return;}
  var lintonVariants=[];try{lintonVariants=JSON.parse(document.querySelector('[data-linton-variants]').textContent);}catch(e){}
  var euro=L.euro;
  function rowOn(key){var c=box.querySelector('.bundle__cb[data-bundle="'+key+'"]');return !!(c&&c.checked);}
  function selVariant(key){
    var sel=box.querySelector('[data-bundle-fin="'+key+'"]');if(!sel){return null;}
    if(key==='linton'){return L.variantById(lintonVariants,sel.value);}
    var data=L.addon(key);return data?L.variantById(data.variants,sel.value):null;
  }
  function paintRow(key,disc){
    var pbox=box.querySelector('[data-bundle-price="'+key+'"]');if(!pbox){return;}
    var v=selVariant(key);if(!v){return;}
    var stockEl=box.querySelector('[data-bundle-row="'+key+'"] .bundle__stock');
    if(stockEl){stockEl.innerHTML=L.stockHtml(v,true);}
    // Afbeelding volgt de gekozen kleurvariant (fallback: productafbeelding).
    var imEl=box.querySelector('[data-bundle-row="'+key+'"] .bundle__img img');
    if(imEl){var ad=key==='linton'?null:L.addon(key),src=v.img||(ad&&ad.img);if(src){imEl.src=src;imEl.removeAttribute('srcset');}}
    var wasEl=pbox.querySelector('[data-was]'),nowEl=pbox.querySelector('[data-now]');
    if(key==='linton'){
      if(nowEl){nowEl.textContent=euro(v.price);}
      if(wasEl){if(v.compare>v.price){wasEl.textContent=euro(v.compare);wasEl.hidden=false;}else{wasEl.hidden=true;}}
      return;
    }
    var proj=Math.max(0,v.price-disc);
    if(nowEl){nowEl.textContent=euro(proj);}
    if(wasEl){if(disc>0){wasEl.textContent=euro(v.price);wasEl.hidden=false;}else{wasEl.hidden=true;}}
  }
  function recompute(){
    var hasLinton=rowOn('linton');
    paintRow('linton',0);
    var total=0,was=0;
    if(hasLinton){var lv=selVariant('linton');if(lv){total+=lv.price;was+=(lv.compare>lv.price?lv.compare:lv.price);}}
    L.KEYS.forEach(function(key){
      var disc=L.discFor(key,hasLinton);
      paintRow(key,disc);
      if(rowOn(key)){var v=selVariant(key);if(v){total+=Math.max(0,v.price-disc);was+=v.price;}}
    });
    var wasEl=document.getElementById('bundleWas'),nowEl=document.getElementById('bundleNow'),saveEl=document.getElementById('bundleSave');
    var s=was-total,pct=was?Math.round(s/was*100):0;
    if(nowEl){nowEl.textContent=euro(total);}
    if(s>0){if(wasEl){wasEl.textContent=euro(was);wasEl.hidden=false;}if(saveEl){saveEl.textContent=euro(s)+' · '+pct+'%';saveEl.hidden=false;}}
    else{if(wasEl){wasEl.hidden=true;}if(saveEl){saveEl.hidden=true;}}
  }
  box.addEventListener('change',recompute);
  var cta=document.getElementById('bundleCta');
  if(cta){cta.addEventListener('click',function(){
    var items=[];
    ['linton'].concat(L.KEYS).forEach(function(key){if(rowOn(key)){var v=selVariant(key);if(v&&v.available){items.push({id:v.id,quantity:1});}}});
    if(!items.length){return;}
    cta.disabled=true;cta.textContent='Bezig…';
    L.cartAdd(items).catch(function(){cta.disabled=false;cta.textContent='Voeg de bundel toe aan winkelwagen';alert('Er ging iets mis bij het toevoegen. Probeer het opnieuw.');});
  });}
  recompute();
})();
(function(){
  var dealers=[
    {name:"Audio Centrum Amsterdam",addr:"Overtoom 256, 1054 JA Amsterdam",hours:"10:00–18:00",chip:"Deze week te beluisteren",premium:true,base:3.2},
    {name:"Klankbeeld Rotterdam",addr:"Nieuwe Binnenweg 112, 3015 BD Rotterdam",hours:"10:00–17:30",chip:"Deze week te beluisteren",premium:true,base:5.6},
    {name:"Reference Audio Den Haag",addr:"Denneweg 15, 2514 EL Den Haag",hours:"11:00–18:00",chip:"Demo op afspraak",premium:true,base:7.1},
    {name:"HiFi Studio Utrecht",addr:"Oudegracht 187, 3511 NE Utrecht",hours:"11:00–17:30",chip:"Demo op afspraak",premium:false,base:4.4},
    {name:"De Luisterkamer Eindhoven",addr:"Kleine Berg 42, 5611 JV Eindhoven",hours:"10:00–18:00",chip:"Deze week te beluisteren",premium:false,base:9.8},
    {name:"Geluidshuis Groningen",addr:"Folkingestraat 28, 9711 JW Groningen",hours:"10:00–17:00",chip:"Demo op afspraak",premium:false,base:12.3},
    {name:"HiFi Corner Arnhem",addr:"Bakkerstraat 61, 6811 EG Arnhem",hours:"10:00–18:00",chip:"Demo op afspraak",premium:false,base:8.2},
    {name:"Puur Klank Breda",addr:"Ginnekenweg 33, 4818 JA Breda",hours:"10:00–17:30",chip:"Deze week te beluisteren",premium:false,base:6.7},
    {name:"Studio Sound Zwolle",addr:"Luttekestraat 9, 8011 LP Zwolle",hours:"11:00–17:00",chip:"Demo op afspraak",premium:false,base:11.1}
  ];
  var topEl=document.getElementById('dealTop'),moreEl=document.getElementById('dealMore'),sel=document.getElementById('apptDealer'),moreBtn=document.getElementById('dealMoreBtn');
  if(!topEl)return;
  function hash(s){var h=0;for(var i=0;i<s.length;i++){h=(h*31+s.charCodeAt(i))>>>0;}return h;}
  function pseudo(search,name){return 1+(hash(search.toLowerCase()+'|'+name)%280)/10;}
  function order(search){
    var list=dealers.map(function(d){return Object.assign({},d);});
    if(!search){
      list.forEach(function(d){d.dist=d.base;});
      var prem=list.filter(function(d){return d.premium;});
      var rest=list.filter(function(d){return !d.premium;}).sort(function(a,b){return a.dist-b.dist;});
      return prem.concat(rest);
    }
    list.forEach(function(d){d.dist=pseudo(search,d.name);});
    list.sort(function(a,b){return a.dist-b.dist;});
    var near=list.slice(0,3),rest=list.slice(3);
    near.sort(function(a,b){if(a.premium!==b.premium){return a.premium?-1:1;}return a.dist-b.dist;});
    return near.concat(rest);
  }
  function km(d){return d.dist.toLocaleString('nl-NL',{minimumFractionDigits:1,maximumFractionDigits:1})+' km';}
  function card(d){
    return '<div class="deal'+(d.premium?' deal--prem':'')+'">'
      +(d.premium?'<span class="deal__prem">Premium dealer</span>':'')
      +'<div class="deal__top"><h3>'+d.name+'</h3><span class="deal__km">'+km(d)+'</span></div>'
      +'<p class="deal__addr">'+d.addr+'</p>'
      +'<span class="deal__chip">'+d.chip+'</span>'
      +'<div class="deal__row"><span>Open · '+d.hours+'</span><a href="#appt" class="deal__appt" data-dealer="'+d.name+'">Maak afspraak →</a></div>'
      +'</div>';
  }
  function render(search){
    var ord=order(search);
    topEl.innerHTML=ord.slice(0,3).map(card).join('');
    moreEl.innerHTML=ord.slice(3).map(card).join('');
    var opts='<option value="">Kies een dealer…</option>';
    ord.forEach(function(d){opts+='<option value="'+d.name+'">'+d.name+(d.premium?' — Premium dealer':'')+'</option>';});
    if(sel){sel.innerHTML=opts;}
    [].slice.call(document.querySelectorAll('.deal__appt')).forEach(function(a){
      a.addEventListener('click',function(){if(sel){sel.value=a.getAttribute('data-dealer');}});
    });
  }
  render('');
  var finderBtn=document.querySelector('.finder button'),finderInput=document.querySelector('.finder input');
  function doSearch(){render(((finderInput&&finderInput.value)||'').trim());}
  if(finderBtn){finderBtn.addEventListener('click',doSearch);}
  if(finderInput){finderInput.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();doSearch();}});}
  if(moreBtn&&moreEl){moreBtn.addEventListener('click',function(){
    moreBtn.classList.toggle('open');moreEl.classList.toggle('open');
    moreBtn.firstChild.textContent=moreEl.classList.contains('open')?'Verberg dealers ':'Bekijk alle dealers ';
  });}
})();
(function(){
  var bar=document.getElementById('stickybar'),cta=document.querySelector('.buy .cta');
  if(!bar||!cta||!('IntersectionObserver' in window))return;
  var io=new IntersectionObserver(function(en){en.forEach(function(e){
    if(!e.isIntersecting && e.boundingClientRect.top < 0){bar.classList.add('show');}
    else{bar.classList.remove('show');}
  });},{threshold:0});
  io.observe(cta);
})();
(function(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els=[].slice.call(document.querySelectorAll('.rv'));
  if(reduce||!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in')});return;}
  var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.14});
  els.forEach(function(e){io.observe(e)});
})();
(function(){
  // Reviewvideo's: openen in een modal op de pagina (geen doorverwijzing naar YouTube).
  var m=document.getElementById('vmodal'),body=document.getElementById('vmodalBody'),close=document.getElementById('vmodalClose');
  if(!m||!body){return;}
  function open(src){
    body.innerHTML='<iframe src="'+src+'" title="Videoreview" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
    m.classList.add('open');m.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow='hidden';
  }
  function shut(){
    m.classList.remove('open');m.setAttribute('aria-hidden','true');
    body.innerHTML='';
    document.documentElement.style.overflow='';
  }
  [].slice.call(document.querySelectorAll('.rev__video[data-video]')).forEach(function(b){
    b.addEventListener('click',function(){open(b.getAttribute('data-video'));});
  });
  if(close){close.addEventListener('click',shut);}
  m.addEventListener('click',function(e){if(e.target===m){shut();}});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){shut();}});
})();
(function(){
  // Reviews: horizontaal swipen door de 2-rijen grid — muis-drag, muiswiel én touch/trackpad.
  var g=document.querySelector('.rev__grid');if(!g){return;}
  var down=false,sx=0,sl=0,moved=false;
  g.addEventListener('mousedown',function(e){down=true;moved=false;sx=e.pageX;sl=g.scrollLeft;e.preventDefault();});
  window.addEventListener('mousemove',function(e){if(!down){return;}var dx=e.pageX-sx;if(Math.abs(dx)>5){moved=true;}g.scrollLeft=sl-dx;});
  window.addEventListener('mouseup',function(){down=false;});
  g.addEventListener('click',function(e){if(moved){e.stopPropagation();e.preventDefault();moved=false;}},true);
  g.addEventListener('dragstart',function(e){e.preventDefault();});
  // Verticaal muiswiel boven de grid → horizontaal scrollen; aan het einde scrollt de pagina gewoon door.
  g.addEventListener('wheel',function(e){
    var d=e.deltaY;
    if(Math.abs(d)<=Math.abs(e.deltaX)){return;}
    var max=g.scrollWidth-g.clientWidth;
    if(max<=0){return;}
    if((d>0&&g.scrollLeft<max-1)||(d<0&&g.scrollLeft>1)){e.preventDefault();g.scrollLeft+=d;}
  },{passive:false});
  // Navigatie: pijlen + pagina-bolletjes zodat duidelijk is dat er meer reviews zijn.
  var nav=document.getElementById('revNav'),prev=document.getElementById('revPrev'),next=document.getElementById('revNext'),dotsWrap=document.getElementById('revDots');
  function pageCount(){return Math.max(1,Math.ceil(g.scrollWidth/g.clientWidth));}
  function update(){
    if(!dotsWrap){return;}
    var max=g.scrollWidth-g.clientWidth;
    var n=dotsWrap.children.length;
    var idx=n>1&&max>0?Math.round(g.scrollLeft/max*(n-1)):0;
    for(var i=0;i<n;i++){dotsWrap.children[i].classList.toggle('on',i===idx);}
    if(prev){prev.disabled=g.scrollLeft<=1;}
    if(next){next.disabled=g.scrollLeft>=max-1;}
  }
  function renderDots(){
    if(!dotsWrap||!nav){return;}
    var n=pageCount();
    nav.style.display=n>1?'':'none';
    dotsWrap.innerHTML='';
    for(var i=0;i<n;i++){(function(i){
      var b=document.createElement('button');
      b.type='button';b.className='rev__dot';b.setAttribute('aria-label','Reviews pagina '+(i+1));
      b.addEventListener('click',function(){g.scrollTo({left:i*g.clientWidth,behavior:'smooth'});});
      dotsWrap.appendChild(b);
    })(i);}
    update();
  }
  if(prev){prev.addEventListener('click',function(){g.scrollBy({left:-g.clientWidth,behavior:'smooth'});});}
  if(next){next.addEventListener('click',function(){g.scrollBy({left:g.clientWidth,behavior:'smooth'});});}
  g.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',renderDots);
  renderDots();
})();

  } catch(e) { console.error(e); }
})();
})();
